import {
  IReportSummaryData,
  IssuingRecordActionEnum,
  IDateRange,
  BookingTypeEnum,
} from './types';
import request from '@/utils/request';
import { sleep } from '@/utils/index';

// request & response
export interface IReportRequest {
  issuingDateRange?: IDateRange;
  participationDateRange?: IDateRange;
  sourceIds?: IReportRequestSourceIdHolder[];
  accountIds?: string[];
}

export interface IDownloadIssuingRecordsResponse {
  url: string;
}

export interface IGetIssueRecordReportResponse {
  summaries: IReportSummaryData[];
}

// data type
export interface IReportRequestSourceIdHolder {
  planId?: string;
  unitId?: string;
}

//mock
const useMock = process.env.VUE_APP_API_USE_MOCK === 'true';

export const defaultReportSummaryData: IReportSummaryData = {
  accountId: 'accountId',
  accountName: 'accountName',
  activityId: 'activityId',
  activityTitle: 'activityTitle',
  planId: '',
  planTitle: 'planTitle',
  unitId: 'unitId',
  unitTitle: 'unitTitle',
  actionId: IssuingRecordActionEnum.ISSUE,
  actionTitle: '',
  amount: 1,
  bookingType: BookingTypeEnum.EACH_TIME,
};

const mockReportSummaryDataById = (id: number, req?: IReportRequest) => {
  const result = Object.assign({}, defaultReportSummaryData);

  result.accountId += id % 9;
  result.accountName += id % 9;
  result.activityId += id % 2;
  result.activityTitle += id % 2;
  result.planId = `${result.activityId}-${id % 2}`;
  result.planTitle += id % 2;
  result.unitId += id % 3;
  result.unitTitle += id % 3;
  if (id % 5 === 0) {
    result.actionId = IssuingRecordActionEnum.ISSUE;
  } else if (id % 5 === 1) {
    result.actionId = IssuingRecordActionEnum.REVOKE;
  } else if (id % 5 === 2) {
    result.actionId = IssuingRecordActionEnum.REFUND;
  } else if (id % 5 === 3) {
    result.actionId = IssuingRecordActionEnum.RECHARGE;
  } else if (id % 5 === 4) {
    result.actionId = IssuingRecordActionEnum.ADMIN_ADJUST;
  }
  result.actionTitle = result.actionId;
  result.amount += id % 5;
  if (id % 3 === 0) {
    result.bookingType = BookingTypeEnum.BULK;
  }
  return result;
};

const mockReportSummaryDataList = (
  req?: IReportRequest,
  totalCount: number = mockReportSummaryDataSize
) => {
  const reports: IReportSummaryData[] = [];
  for (let i = 0; i < totalCount; i++) {
    reports.push(mockReportSummaryDataById(i, req));
  }
  return reports;
};

const mockReportSummaryDataSize = 100;

const defaultMockDownloadUrl = 'https://dummy.url/dummy.csv';

// api
export const getIssuingReport = async (req: IReportRequest) => {
  if (useMock) {
    await sleep(1000);
    return {
      summaries: mockReportSummaryDataList(req),
    } as IGetIssueRecordReportResponse;
  }

  const res = await request({
    url: 'v1/get-issuing-report',
    method: 'post',
    data: req,
  });
  return res.data as IGetIssueRecordReportResponse;
};

export const downloadIssuingReport = async (req: IReportRequest) => {
  if (useMock) {
    await sleep(1000);
    return {
      url: `${defaultMockDownloadUrl}?req=${JSON.stringify(req)}`,
    } as IDownloadIssuingRecordsResponse;
  }

  const res = await request({
    url: 'v1/download-issuing-records',
    method: 'post',
    data: req,
  });
  return res.data as IDownloadIssuingRecordsResponse;
};
